// Firebase Analytics
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCsszSeh45KcIycbqJ60A-5-_V0nImijXc",
  authDomain: "easyremessa.firebaseapp.com",
  databaseURL: "https://easyremessa.firebaseio.com",
  projectId: "easyremessa",
  storageBucket: "easyremessa.appspot.com",
  messagingSenderId: "479342807014",
  appId: "1:479342807014:web:cbb92c7456e2eb19417827",
  measurementId: "G-30G47KZ8WC"
};

export default firebase.initializeApp(firebaseConfig);

